import { render, staticRenderFns } from "./FacilitiesFilter.vue?vue&type=template&id=b48afade&"
import script from "./FacilitiesFilter.vue?vue&type=script&lang=ts&"
export * from "./FacilitiesFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports